const searchToggle = document.querySelector(".searchToggle");
const svgUseElement = searchToggle.querySelector(".icon use");
const desktopSearch = document.querySelector("#desktopSearch");

function openSearch() {
    searchToggle.setAttribute("aria-expanded", "true");

    const newLabel = searchToggle.getAttribute("data-close-label");
    searchToggle.setAttribute("aria-label", newLabel);

    svgUseElement.setAttribute("xlink:href", "#iconClose");

    document.body.classList.add("searchActive");

    // Get the search input field and set focus on it after a brief delay
    setTimeout(() => {
      const searchInput = document.querySelector("#desktopSearchBar");
      if (searchInput) {
        searchInput.focus();
      }
    }, 200); // Adjust the delay as needed
  }

  function closeSearch() {
    searchToggle.setAttribute("aria-expanded", "false");

    const newLabel = searchToggle.getAttribute("data-open-label");
    searchToggle.setAttribute("aria-label", newLabel);

    svgUseElement.setAttribute("xlink:href", "#iconSearch");

    document.body.classList.remove("searchActive");

  }

  function toggleSearch(event) {
    if (event) event.stopPropagation();

    const isExpanded = searchToggle.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      closeSearch();
    } else {
      openSearch();
    }
  }


function setupSearchEventListeners() {
    const searchButton = document.querySelector(".searchButton");

    if (searchToggle) {

      if (!searchToggle || !desktopSearch || !svgUseElement) {
        return;
      }

      searchToggle.addEventListener("click", toggleSearch);
      document.addEventListener("click", (event) => {
        const isClickInside =
          desktopSearch.contains(event.target) ||
          searchToggle.contains(event.target);

        if (
          !isClickInside &&
          searchToggle.getAttribute("aria-expanded") === "true"
        ) {
          closeSearch();
        }
      });

      // Close search and remove searchActive when tabbing past the search button
      searchButton.addEventListener("blur", () => {
        setTimeout(() => {
            const focusedElement = document.activeElement;
            const searchInput = document.querySelector("#desktopSearchBar");

            // If focus is not on the search input or search button, close search and remove searchActive
            if (focusedElement !== searchInput && focusedElement !== searchButton) {
                closeSearch();
                document.body.classList.remove("searchActive");
            }
        }, 10);
    });
  }
}


setupSearchEventListeners();